'use client';

import React, { forwardRef } from 'react';
import omit from 'lodash-es/omit';
import clsx from 'clsx';
import { Box, BoxProps } from '@shared/ui';
import STYLE from './ShopUIWrapper.module.scss';

type ShopUIWrapperProps = BoxProps & {
    isEditingMode: boolean;
    enable?: boolean;
};

export const ShopUIWrapper = forwardRef<HTMLDivElement, ShopUIWrapperProps>(
    (props, ref) => {
        return (
            <Box
                ref={ref}
                className={clsx(STYLE.shopUIWrapper, props.className)}
                {...omit(props, ['className', 'isEditingMode'])}
            />
        );
    }
);

ShopUIWrapper.displayName = 'ShopUIWrapper';
